import { isNil } from 'lodash';

import { ConversationSpamDetectionConfig } from '@pwp-common';

import { defaultSpamDetectionConfigEditorOutput } from '../default-spam-detection-config-editor-output';
import { SpamDetectionConfigEditorOutput } from '../spam-detection-config-editor-output';

export const dbToSpamDetectionConfigEditorOutput = (
  spamDetectionConfig: ConversationSpamDetectionConfig | undefined | null,
): SpamDetectionConfigEditorOutput => {
  if (isNil(spamDetectionConfig)) {
    return defaultSpamDetectionConfigEditorOutput;
  }

  return {
    enabled: spamDetectionConfig.getEnabled(),
    instructions: spamDetectionConfig.getInstructions(),
    spamDetectedMessage: spamDetectionConfig.getSpamDetectedMessage(),
    spamFilteringPassedMessage: spamDetectionConfig.getSpamFilteringPassedMessage(),
  };
};
